import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss']
})
export class ListViewComponent implements OnInit {

  @Input() title: string = null;
  @Input() messages: Array<any> = [];
  @Input() loading = false;

  constructor() { }

  ngOnInit(): void {
  }

}
